import { signal, effect } from '@preact/signals';

export type OfflineModeStatus = 'online' | 'downloading' | 'offline-partial' | 'offline-full';

function loadStatus(): OfflineModeStatus {
  if (typeof localStorage === 'undefined') return 'online';
  return (localStorage.getItem('_om1') as OfflineModeStatus) ?? 'online';
}

export const offlineModeStatus = signal<OfflineModeStatus>(loadStatus());

if (typeof window !== 'undefined') {
  effect(() => {
    try {
      localStorage.setItem('_om1', offlineModeStatus.value);
    } catch {
      /* quota — ignore */
    }
  });

  effect(() => {
    if (!navigator.serviceWorker?.controller) return;
    navigator.serviceWorker.controller.postMessage({
      type: 'SET_OFFLINE_MODE',
      enabled: offlineModeStatus.value === 'offline-full',
    });
  });
}

export function setGoDark(enabled: boolean): void {
  offlineModeStatus.value = enabled ? 'offline-full' : 'offline-partial';
}
